import { createFileRoute, notFound } from "@tanstack/react-router";
import { LegalView } from "@/components/pages/LegalView";
import { cookies } from "@/content/legal";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/cookies")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/cookies",
          ...meta[params.locale].cookies,
        })
      : {},
  component: CookiesRoute,
});

function CookiesRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LegalView locale={locale} doc={cookies[locale]} />;
}
